import React, { FC } from 'react';
import classNames from 'classnames/bind';
import Text from '../../../atoms/Text';
import styles from './EmailOtp.pcss';

const cx = classNames.bind(styles);

interface personalInfoUserProps {
  otp: string;
  message: string;
  statusCode: string;
  secondsRemaining?: number;
  personalInfo: any;
  otpTitle: string;
  otpDescription: string;
  otpSubmitBtn: string;
  submitUserOTP: any;
  resendOTP: any;
  handleOTPChange: any;
  enterPressed: any;
  isAccountDelete: Boolean
}

const UserOtpVerifyInfo: FC<any> = (props: personalInfoUserProps) => {
  const {
    otp = '',
    message = '',
    statusCode = '',
    secondsRemaining = '',
    otpTitle,
    otpDescription,
    otpSubmitBtn,
    isAccountDelete = false
  } = props;
  const {
    personalInfo: { profile: { mobileNumber = '', displayUid: emailId = '', uid = '' } = {} } = {}
  } = props;
  const USER_MOBILE_NUMBER = mobileNumber;
  const label = {
    userProfileOtp: `${otpTitle}`,
    userDetail: `${otpDescription} <span>${isAccountDelete ? mobileNumber : emailId}</span>`,
    otpDigitLabel: '6-digit OTP',
    otpLabel: 'OTP',
    valid: 'Valid for 10 mins',
    resendOtp: 'Resend OTP',
    resendTime: `Resend OTP in ${secondsRemaining}s`,
    incorrectOTP: 'Incorrect OTP entered. Please try again'
  };
  const ERROR_MESSAGE = message || label.valid;
  const CUSTOM_ERROR_CLASS = message ? 'invalid-otp' : 'message';
  const RESEND_LABEL = secondsRemaining > 0 ? label.resendTime : label.resendOtp;
  const CUSTOM_RESEND = secondsRemaining > 0 ? 'resend-time' : 'resend-otp';
  return (
    <div className={cx('otp-container')}>
      <header>
        <Text variant="T4" color="Nero" weight="bold">
          {label.userProfileOtp}
        </Text>
      </header>
      <div
        className={cx('user-detail')}
        dangerouslySetInnerHTML={{ __html: label.userDetail }}
        aria-label={label.userDetail}
      />
      <div className={cx('enter-otp')}>
        <div className={cx('otp-input-field')}>
          <input
            type="number"
            id="name"
            name="mobileOTP"
            value={otp}
            onChange={props.handleOTPChange}
            onKeyPress={e => props.enterPressed(e, otp, USER_MOBILE_NUMBER, uid)}
            aria-label="mobileOTP"
          />
          <label
            htmlFor="name"
            data-content={otp === '' ? label.otpDigitLabel : label.otpLabel}
            aria-label={otp === '' ? label.otpDigitLabel : label.otpLabel}
          />
          <span
            dangerouslySetInnerHTML={{ __html: RESEND_LABEL }}
            aria-label={RESEND_LABEL}
            className={cx(`${CUSTOM_RESEND}`)}
            onClick={() => props.resendOTP(USER_MOBILE_NUMBER, uid)}
          />
        </div>
        <div>
          <span
            className={cx(`${CUSTOM_ERROR_CLASS}`)}
            aria-label={ERROR_MESSAGE}
            aria-live={CUSTOM_ERROR_CLASS === 'invalid-otp' ? 'polite' : ''}
          >
            {ERROR_MESSAGE}
          </span>
        </div>
      </div>
      <div
        className={cx('submit-otp', otp === '' ? 'disabled-btn' : '')}
        onClick={e => props.submitUserOTP(e, otp, mobileNumber, uid)}
        aria-label={otpSubmitBtn}
      >
        {otpSubmitBtn}
      </div>
    </div>
  );
};

export default UserOtpVerifyInfo;
